import { Job, LeadApplicant } from '@kanda-libs/ks-frontend-services';

export type PrefilledCustomerDetails = Pick<
  Partial<LeadApplicant['customer_details']>,
  'first_name' | 'last_name' | 'email' | 'mobile'
>;

export const formatInitialCustomerData = (
  job?: Job,
): PrefilledCustomerDetails | undefined => {
  const customer = job?.customer;

  if (!customer) return undefined;

  return {
    first_name: customer?.first_name || '',
    last_name: customer?.last_name || '',
    email: customer?.email || '',
    mobile: customer?.phone || '',
  };
};
